import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CenteredLayoutComponent } from './components/centered-layout/centered-layout.component';
import { RouterModule } from '@angular/router';
import { EventApiService } from '../../events/services/event-api/EventApiService';

@NgModule({
  declarations: [
    MainLayoutComponent,
    SidebarComponent,
    NavbarComponent,
    CenteredLayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ], exports: [
    MainLayoutComponent,
    CenteredLayoutComponent,
  ],
  providers: [
    provideHttpClient(),
    EventApiService,
  ],
})
export class LayoutModule { }
